import { TFunction } from "react-i18next";
import { getMonthName } from "go-core/components/Formatters/FormatDate";
import { FILTER_VALUE_SEPARATOR } from "go-list/core/components/Filter/services";
import { UserOrganizationState, UserState } from "go-security/services/users/types";
import { api } from "../../../../../../../services/Api/api";

export const getOrganizations = (orgs?: UserOrganizationState[]) => {
	const orgObj: Record<number, string> = {};
	orgs?.forEach((org) => {
		orgObj[org.id] = org.name;
	});
	return orgObj;
};

export const getUserReportsBasicFilters = (t: TFunction, user: UserState, organizationIds: number[]) => {
	return [
		{
			id: "stock_uuids",
			name: t("common.word.stock"),
			type: "search_select",
			source: {
				request: (search: string, params: Record<string, any>, options?: Record<string, any>) => {
					const newParams = {
						...params,
						organizationIds: organizationIds.map((id) => id).join(FILTER_VALUE_SEPARATOR),
					};
					return api.getStockSearchSelect(search, newParams, {
						cancelToken: options?.token,
					});
				},
			},
		},
		{
			id: "product_name",
			name: t("common.word.product"),
			type: "text",
		},
		{
			id: "category_name",
			name: t("common.word.category"),
			type: "text",
		},
		{
			id: "contact_name",
			name: t("common.word.contact"),
			type: "text",
		},
		{
			id: "product_statuses",
			name: t("common.word.product_status"),
			type: "list",
			listOptions: {
				ENABLED: t("enums.common.status.ENABLED", { ns: "lib" }),
				DISABLED: t("enums.common.status.DISABLED", { ns: "lib" }),
				DELETED: t("enums.common.status.DELETED", { ns: "lib" }),
			},
		},
		{
			id: "organization_ids",
			name: t("modules.sale_report.field.organization_ids.title"),
			type: "list",
			listOptions: getOrganizations(user.organizations),
			sortAlphabetically: true,
			hasDefaultOptions: false,
		},
	];
};

export const getUserReportsBasicGroupsInfo = (t: TFunction) => ({
	MONTH: (groupByValue: Record<string, any>) => {
		if (!groupByValue.name) return "";
		return getMonthName(groupByValue.name, t);
	},
});
